@if (isEditing) {
<div class="inline-edit-editor" (focusout)="onFocusOut($event)" [attr.data-testid]="'inline-edit-editor-' + key">
  <ng-container #fieldComponent></ng-container>
</div>
} @else {
<div class="inline-edit-display" [class.inline-edit-title]="isTitle" [attr.data-testid]="'inline-edit-' + key">
  @if (isEmpty()) {
  <span class="inline-edit-placeholder">{{ props.placeholder }}</span>
  } @else {
  <span class="inline-edit-value">{{ displayValue }}</span>
  }
  <app-button variant="icon" size="sm" type="button" (click)="startEditing()"
    [attr.aria-label]="'inlineEdit.edit' | translate: { field: props.label ?? '' }"
    [attr.data-testid]="'inline-edit-button-' + key">
    <app-icon name="pencil" [size]="16" />
  </app-button>
</div>
}
